import { Grid } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import TextField from '@mui/material/TextField';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import EditButtonGroup from '../../../Shared/FormControls/Buttons/EditButtonGroup';

const useStyles = makeStyles()((theme: Theme) => ({
    rootGrid: {
        display: 'contents',
    },
    txtEditName: {
        color: 'grey',
    },
}));

interface ComponentState {
    firstName: string;
    lastName: string;
}

interface Props {
    menuId: string;
    firstName: string;
    lastName: string;
    onCloseHandler: () => void;
    onSubmitHandler: (firstName: string, lastName: string) => void;
}
export default function DialogModifyContactNameRaw({
    menuId,
    firstName,
    lastName,
    onCloseHandler,
    onSubmitHandler,
}: Props) {
    const { classes } = useStyles();

    const [fullName, setFullName] = React.useState<ComponentState>({
        firstName: firstName,
        lastName: lastName,
    });

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setFullName({ ...fullName, [name]: value });
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') onSubmitHandler(fullName.firstName, fullName.lastName);
    };

    const handleSubmit = () => {
        onSubmitHandler(fullName.firstName, fullName.lastName);
    };

    return (
        <ClickAwayListener onClickAway={onCloseHandler}>
            <Grid
                className={classes.rootGrid}
                container
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs onKeyDown={handleKeyDown}>
                    <TextField
                        id={menuId}
                        name="firstName"
                        placeholder="First Name"
                        onChange={handleChange}
                        value={fullName.firstName}
                        autoFocus
                    ></TextField>
                    <TextField
                        id={menuId}
                        name="lastName"
                        placeholder="Last Name"
                        onChange={handleChange}
                        value={fullName.lastName}
                    ></TextField>
                </Grid>
                <Grid item>
                    <EditButtonGroup
                        onSave={handleSubmit}
                        onCancel={onCloseHandler}
                        allowDelete={false}
                        size="small"
                    />
                </Grid>
            </Grid>
        </ClickAwayListener>
    );
}
